var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "caja_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 34,
    height: 34,
    transform: "translate(820 129)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 19.608,
    height: 24.521,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(-820 -129)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(827.196 134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M17.107,24.52H2.509c-.022-.012-.042-.034-.065-.036A2.909,2.909,0,0,1,0,21.489C.021,15.335.007,9.181.011,3.027a3.6,3.6,0,0,1,.078-.809A2.836,2.836,0,0,1,2.9,0C5.226,0,7.548,0,9.87,0c2.279,0,4.559,0,6.838,0a2.842,2.842,0,0,1,2.76,1.991c.054.168.094.341.14.511V22.017a1.161,1.161,0,0,0-.048.14,2.831,2.831,0,0,1-1.991,2.24c-.15.051-.308.082-.462.122M.825,12.247q0,4.635,0,9.27A2.051,2.051,0,0,0,3.014,23.7H16.59a2.053,2.053,0,0,0,2.2-2.2q0-9.245,0-18.489a2.051,2.051,0,0,0-2.2-2.2H3.039A2.054,2.054,0,0,0,.825,3.028q0,4.61,0,9.219",
    transform: "translate(0 0.001)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M18.43,10.219h6.787A1.239,1.239,0,0,1,26.584,11.6q0,1.494,0,2.988a1.234,1.234,0,0,1-1.341,1.354H11.593a1.232,1.232,0,0,1-1.342-1.328q0-1.532,0-3.064a1.232,1.232,0,0,1,1.341-1.328H18.43m-.013.817H11.6c-.4,0-.535.135-.535.536q0,1.507,0,3.014c0,.4.136.536.536.536H25.232c.4,0,.535-.136.536-.537q0-1.481,0-2.963c0-.469-.118-.587-.588-.587H18.417",
    transform: "translate(-8.609 -8.583)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M81.671,91.3q0-1.6,0-3.191a1.227,1.227,0,0,1,1.307-1.311q1.148,0,2.3,0a1.223,1.223,0,0,1,1.3,1.3q0,3.2,0,6.408a1.221,1.221,0,0,1-1.281,1.285q-1.174.005-2.347,0a1.221,1.221,0,0,1-1.27-1.27c0-1.072,0-2.145,0-3.217m4.083-.007q0-1.583,0-3.167c0-.367-.144-.51-.509-.511q-1.123,0-2.246,0c-.367,0-.51.143-.51.51q0,3.167,0,6.334c0,.367.143.51.509.511q1.11,0,2.22,0c.4,0,.536-.136.537-.536q0-1.57,0-3.141",
    transform: "translate(-68.595 -72.899)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M12.715,56.161c.391,0,.782,0,1.173,0A1.22,1.22,0,0,1,15.14,57.4q.01.8,0,1.608a1.217,1.217,0,0,1-1.248,1.24q-1.2.008-2.4,0a1.22,1.22,0,0,1-1.252-1.262c0-.527-.005-1.055,0-1.582a1.22,1.22,0,0,1,1.248-1.24c.408,0,.816,0,1.224,0m-.025,3.269c.383,0,.766,0,1.148,0,.334,0,.483-.151.486-.483q.005-.741,0-1.481c0-.334-.15-.484-.483-.485q-1.148,0-2.3,0c-.335,0-.483.15-.485.483q-.005.741,0,1.481c0,.335.15.483.482.486.383,0,.766,0,1.148,0",
    transform: "translate(-8.6 -47.17)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M48.4,60.241c-.408,0-.816.005-1.224,0A1.219,1.219,0,0,1,45.95,59q-.009-.8,0-1.608A1.218,1.218,0,0,1,47.2,56.156q1.2-.008,2.4,0a1.219,1.219,0,0,1,1.252,1.262q.007.779,0,1.557a1.223,1.223,0,0,1-1.274,1.266c-.391,0-.782,0-1.173,0m-.019-.817c.391,0,.782,0,1.174,0a.417.417,0,0,0,.476-.467q.007-.753,0-1.507c0-.32-.152-.474-.467-.476q-1.161-.006-2.322,0a.415.415,0,0,0-.476.466q-.007.753,0,1.507c0,.329.154.474.492.477.374,0,.749,0,1.123,0",
    transform: "translate(-38.59 -47.163)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M84.087,60.235c-.4,0-.8,0-1.2,0A1.219,1.219,0,0,1,81.658,59c-.006-.544-.007-1.089,0-1.634a1.214,1.214,0,0,1,1.218-1.217q1.224-.012,2.448,0a1.215,1.215,0,0,1,1.23,1.232c.007.544.008,1.089,0,1.633a1.217,1.217,0,0,1-1.218,1.218c-.417.007-.833,0-1.25,0m.02-3.269c-.383,0-.766,0-1.148,0-.334,0-.482.15-.484.484q-.005.741,0,1.481c0,.334.15.483.484.484q1.148,0,2.3,0c.333,0,.482-.151.484-.485q.006-.741,0-1.481c0-.334-.151-.481-.484-.484-.383,0-.766,0-1.148,0",
    transform: "translate(-68.582 -47.157)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M12.666,90.865c-.4,0-.8.005-1.2,0a1.219,1.219,0,0,1-1.23-1.232c-.007-.544-.008-1.089,0-1.634a1.214,1.214,0,0,1,1.218-1.217q1.237-.012,2.474,0a1.21,1.21,0,0,1,1.2,1.2c.01.561.011,1.123,0,1.684a1.213,1.213,0,0,1-1.191,1.192c-.425.011-.85,0-1.275,0m0-.817c.383,0,.766,0,1.148,0,.353,0,.5-.146.5-.491q.005-.741,0-1.481c0-.33-.153-.477-.49-.478q-1.148,0-2.3,0c-.331,0-.476.152-.478.49q0,.741,0,1.481c0,.331.153.476.49.479.374,0,.749,0,1.123,0",
    transform: "translate(-8.594 -72.883)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M48.394,90.868c-.4,0-.8,0-1.2,0a1.22,1.22,0,0,1-1.245-1.243q-.008-.8,0-1.608a1.216,1.216,0,0,1,1.229-1.232q1.224-.011,2.448,0A1.213,1.213,0,0,1,50.846,88q.013.829,0,1.659a1.215,1.215,0,0,1-1.2,1.207c-.416.009-.833,0-1.25,0m-.015-.817c.383,0,.766,0,1.148,0,.353,0,.5-.146.5-.491q.005-.741,0-1.481c0-.33-.153-.477-.49-.478q-1.148,0-2.3,0c-.331,0-.476.152-.478.49q0,.741,0,1.481c0,.331.153.476.49.479.374,0,.748,0,1.123,0",
    transform: "translate(-38.59 -72.886)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M12.678,121.509c-.391,0-.782,0-1.173,0a1.222,1.222,0,0,1-1.263-1.252q-.007-.791,0-1.582a1.22,1.22,0,0,1,1.263-1.251q1.186-.006,2.372,0a1.219,1.219,0,0,1,1.263,1.251q.008.791,0,1.582a1.221,1.221,0,0,1-1.263,1.251c-.4,0-.8,0-1.2,0m.042-3.269c-.391,0-.783,0-1.174,0-.336,0-.485.148-.487.481q-.006.741,0,1.481c0,.336.149.487.48.488q1.148,0,2.3,0c.335,0,.485-.15.488-.481q.006-.741,0-1.481c0-.336-.149-.484-.481-.488-.374,0-.748,0-1.123,0",
    transform: "translate(-8.6 -98.623)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M48.4,121.5c-.4,0-.8,0-1.2,0a1.22,1.22,0,0,1-1.248-1.24q-.009-.8,0-1.608a1.216,1.216,0,0,1,1.226-1.235q1.224-.011,2.448,0a1.214,1.214,0,0,1,1.222,1.213q.013.829,0,1.659a1.217,1.217,0,0,1-1.225,1.211c-.408.007-.816,0-1.224,0m0-.817c.383,0,.766,0,1.148,0,.336,0,.487-.149.49-.479q.006-.741,0-1.481c0-.337-.148-.489-.479-.49q-1.148-.005-2.3,0c-.337,0-.487.147-.49.478q-.006.741,0,1.481c0,.346.15.489.5.491.374,0,.749,0,1.123,0",
    transform: "translate(-38.591 -98.614)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M91.745,19.525c0,.153.006.307,0,.459a1.223,1.223,0,0,1-2.443,0c-.013-.314-.013-.629,0-.944a1.223,1.223,0,0,1,2.443,0c.008.161,0,.323,0,.485m-1.628-.018h0c0,.145-.009.29,0,.434a.4.4,0,0,0,.4.389.4.4,0,0,0,.41-.374,7.351,7.351,0,0,0,0-.893.376.376,0,0,0-.392-.362.4.4,0,0,0-.41.372c-.013.144,0,.289,0,.434",
    transform: "translate(-74.997 -15.018)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon_box.41406f5f4ee5ab3254c38717182b8558.svg";
export { ForwardRef as ReactComponent };